import { render, staticRenderFns } from "./loginTest.vue?vue&type=template&id=732cb0b8"
import script from "./loginTest.vue?vue&type=script&lang=js"
export * from "./loginTest.vue?vue&type=script&lang=js"
import style0 from "./loginTest.vue?vue&type=style&index=0&id=732cb0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports